import React from 'react'


const ServicesLastAbout = () => {
  return (
    <div className='container mtop-5'>
        <h2 className='heading text-start mb-3'>Study Abroad Counselling and <br/> Complete Student Support</h2>
<p className='text-muted text-start'>Your study abroad journey is one of the most important chapters of your life. With our comprehensive services—career counselling, University selection, application processing, financial aid guidance, pre-departure sessions, travel & forex support, and post-arrival assistance—you can focus on achieving your dreams while we handle the details.
</p>
<p className='text-muted text-start mb-5'>Whether you’re searching for a career counselor near me, need career counselling online, or want the expertise of a personal career coach, we are here to ensure your success from start to finish. Let us be your trusted partner in turning your academic aspirations into a reality.

</p>
    </div>
  )
}

export default ServicesLastAbout